import { render } from "./Order.vue?vue&type=template&id=0fc2e298"
import script from "./Order.vue?vue&type=script&setup=true&lang=js"
export * from "./Order.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/pages/Order.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fc2e298"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fc2e298', __exports__)) {
    console.log('reload')
    api.reload('0fc2e298', __exports__)
  }
  
  module.hot.accept("./Order.vue?vue&type=template&id=0fc2e298", () => {
    console.log('re-render')
    api.rerender('0fc2e298', render)
  })

}


export default __exports__